import { QueueRuleAction } from '../../../rules/models/queueRule';
import { Url } from '../../../types';
import {
  suggestRulePayloadSchema,
  suggestRuleResponseSchema,
} from './suggestRule.schema';

export type SuggestRulePayload = {
  userQuery: string;
  queue: Url;
};

export type SuggestRuleResult = {
  description?: string;
  enabled?: boolean;
  id?: string;
  triggerCondition?: string;
  triggerConditionSummary?: string;
  name?: string;
  actions?: Partial<QueueRuleAction>[];
};

export type SuggestRuleResponse = {
  results: Array<SuggestRuleResult>;
};

export const suggestRule = (payload: SuggestRulePayload) =>
  ({
    endpoint: `internal/rules/suggest_rule`,
    method: 'POST',
    responseSchema: suggestRuleResponseSchema,
    payloadSchema: suggestRulePayloadSchema,
    payload,
  }) as const;
